export default __webpack_public_path__ + "static/media/Bipashna.a43bf7be.png";